import React, { useState } from "react";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

import { DateRangePickerContainer } from "./styled";

const DateRangePickerComp = ({ onClose, customStyle = {} }) => {
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [focusedInput, setFocusedInput] = useState(null);

	return (
		<DateRangePickerContainer
			style={{
				...customStyle
			}}
		>
			<DateRangePicker
				startDatePlaceholderText="Data Inicial"
				startDate={startDate}
				startDateId="your_unique_start_date_id"
				endDatePlaceholderText="Data Final"
				endDate={endDate}
				endDateId="your_unique_end_date_id"
				onDatesChange={({ startDate, endDate }) => {
					setStartDate(startDate);
					setEndDate(endDate);
				}}
				focusedInput={focusedInput}
				onFocusChange={focusedInput => setFocusedInput(focusedInput)}
				onClose={onClose}
				small={true}
				isOutsideRange={() => false}
				noBorder={true}
			/>
		</DateRangePickerContainer>
	);
};

export default DateRangePickerComp;
